import Relay from 'react-relay';
import Producers from './Producers';
import PersonEntry from '../Entry';
import PageHeader from '../../shared/PageHeader';
import settings from '../../../../config/settings';
import {getCurrentLanguage} from '../../../localData';

const ProducersContainer = Relay.createContainer(Producers, {
    initialVariables: {
        limit: settings.defaultLimitNumberOfRecords,
        lang: getCurrentLanguage() || settings.defaultLanguage,
        nameStartsWith: null,
    },
    fragments: {
        store: () => Relay.QL`
            fragment on Store {
                lang,
                allProducers(first: $limit, lang: $lang, nameStartsWith: $nameStartsWith) {
                    edges {
                        node {
                            id,
                            ${PersonEntry.getFragment('person')}
                        }
                    }
                },
                ${PageHeader.getFragment('store')}
            }
        `
    }
});

export default ProducersContainer;


// WEBPACK FOOTER //
// ./app/components/Person/Producers/index.js